/* eslint-disable @typescript-eslint/no-explicit-any */

import { TFunction } from 'i18next';
import { TPartnerConfigurationDetails } from 'typings/partner';
import { DEFAULT_TRANSLATIONS } from '../../utils/translationFunctions';

// Create a function that returns the config and accepts an optional translation function
export const getLunaConfig = (t?: TFunction): TPartnerConfigurationDetails => {
  // Use either the passed translation function or default to build-time values
  const translations = DEFAULT_TRANSLATIONS.luna;

  // Handle translation with fallbacks to build-time defaults
  const translate = (
    key: string,
    options?: object,
    fallback?: string
  ): string => {
    if (t) {
      try {
        const translation = t(key, options as any);
        return translation !== key
          ? translation
          : fallback || translations[key as keyof typeof translations] || key;
      } catch (error) {
        console.warn(`Translation failed for key: ${key}`, error);
        return (
          fallback || translations[key as keyof typeof translations] || key
        );
      }
    }
    return translations[key as keyof typeof translations] || fallback || key;
  };

  return {
    nameOfCompany: 'Luna Home',
    typeOfCompany: 'LLC.',
    singinLabel: translate('signIn', undefined, 'Sign In') as string,
    welcomeText: translate(
      'welcomeText',
      {
        partnerName: 'Luna AI'
      },
      'Welcome to Luna AI'
    ) as string,
    label: 'Luna AI',
    supportEmail: 'lunasupport@lunahome.com',
    supportEmail2: 'lunasupport@lunahome.com',
    phoneNumber: '+1 (855) 604-5862',
    companyAddress: '450 North 1500 West Orem, Utah 84057',
    updateDeteOfPrivacyPolicy: 'September 11, 2024',
    updateDeteOfTermsOfService: 'September 11, 2024',
    iosAppLink: 'https://apps.apple.com/us/app/luna-ai/id6511216510',
    androidAppLink:
      'https://play.google.com/store/apps/details?id=com.lunahomeai.homesecurity'
  };
};

// Export a static config for bundling/tree-shaking
const lunaConfig = getLunaConfig();
export default lunaConfig;
